import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  containedProfile: { padding: theme.spacing(2, 4, 1) },
  loadingLayout: { display: 'flex', flexDirection: 'column' }
}));
